import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrl: './error-dialog.component.scss',
    standalone: false
})
export class ErrorDialogComponent {

  readonly dialogRef = inject(MatDialogRef<ErrorDialogComponent>);
  readonly data = inject(MAT_DIALOG_DATA)

  constructor() { }

  close() {
    this.dialogRef.close();
  }
}
